import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { taskTemplateBulkSchemaObject } from "../taskTemplateBulkSchema";
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import { PageHeader } from "../../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import collectionCatagoryService from "../../CollectionCategory/services";
import { MultiSelect } from "../../../Common/multiSelect";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const screenCode = "TASKTEMPLATEBULK";

export function AddTaskTemplateBulk(props) {

  const [selectedOptions, setSelectedOptions] = useState([]);
  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === "foo";
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(alldeductionType);
    } else {
      handleClearOptions();
    }
  };
  const [pageProperties, setPageProperties] = useState({
    title: "Add Task Template Bulk",
    buttonText: "Save",
  });
  const [groups, setGroups] = useState();
  const [factoriesData, setFactoriesData] = useState();
  const [taskCategory, setTaskCategory] = useState();
  const [estates, setEstates] = useState()
  const [labourTask, setLabourTask] = useState()
  const [isDropdownDisable, setIsDropdownDisable] = useState(false);
  const [alldeductionType, setAllDeductionType] = useState([]);
  const [deductionType, setDeductionType] = useState();
  const [applyMethods, setApplyMethods] = useState();
  const [deduction, setDeduction] = useState({
    deductionTemplateID: "0",
    groupID: 0,
    groupName: "",
    operationEntityID: "0",
    factoryName: "",
    collectionPointID: 0,
    collectionCategoryMenuID: 0,
    collectionPointName: "",
    deductionTypeID: 0,
    deductionTypeName: "",
    applyMethodID: "0",
    collectionCategoryID: 0,
    defaultValue: 0,
    minimumValue: 0,
    isFixed: false,
    isActive: true,
    isDefaultValueEnabled: false,
    createdBy: 0,
    createdDate: "",
    entityTypeID: 0,
    estateTaskID: "0",
    date: "",
    numberOfWorkers: "",
    sundryTask: "0",
    isCirculation: false,
    fixedDeductions: [],
  });
  const [errors, setErrors] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [collectionCategoryMenus, setCollectionCategoryMenus] = useState();
  const [deletedValues, setDeletedValues] = useState({
    deleted: [],
  });
  const schema = Joi.object(taskTemplateBulkSchemaObject).options({
    allowUnknown: true,
  });
  const [state, setState] = useState({
    columns: [
      { title: "Deduction Type", field: "name" },
      { title: "Value", field: "value", type: "numeric" },
    ],
    data: [],
  });
  const [stateData, setStateData] = useState(0);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (deduction.groupID != 0) {
      trackPromise(getEstates());
    }
  }, [deduction.groupID]);

  useEffect(() => {
    trackPromise(getTaskNames()
      );

  }, [deduction.operationEntityID]);

  useEffect(() => {
    trackPromise(getLabourTask());

  }, [deduction.estateTaskID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());

  }, [deduction.sundryTask]);

  function handleIncrement() {
    let stat = stateData;
    stat++;
    setStateData(stat);
  };

  function handleDecrement() {
    let stat = stateData;
    stat--;
    stat >= 0 ? 
    setStateData(stat) : setStateData(0)
  };

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "ADDTASKTEMPLATEBULK"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setDeduction({
      ...deduction,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });
    trackPromise(
      setGroupDropDownData(),
      setApplyMethodsData(),
      setDeductionTypeDropDownData()
    );
  }

  async function setGroupDropDownData() {
    const result = await services.getGroups();
    setGroups(result);
  }

  async function getOperationEntitiesForDropdown() {
    const opEntities = await services.getAllOperationEntitiesForDropDown(deduction.groupID);
    setFactoriesData(opEntities);
  }

  async function getEstates() {
    const result = await services.GetAllOperationEntityByGroupID(deduction.groupID)
    setEstates(result)
  }

  async function getLabourTask() {
    const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(deduction.operationEntityID, deduction.estateTaskID)
    setLabourTask(result)
  }

  async function getDivisionsForDropDown() {
    let data = await services.GetCollectionPointByOperationEntityIDLabourTaskID(deduction.operationEntityID,deduction.sundryTask);
    var options = []
    for (let item of Object.entries(data)) {
      options.push({ label: item[1]["collectionPointName"], value: item[1]["collectionPointID"] });
    }
    setAllDeductionType(options);
  }

  async function setCollectionCategoryMenusDropDownData() {
    const result = await services.getAllCollectionCategoryMenusForDropdown(deduction.collectionCategoryID);
    setCollectionCategoryMenus(result);
  }

  async function setDeductionTypeDropDownData() {
    const result = await services.getDeductionTypes();
    setDeductionType(result);
  }

  async function getTaskNames() {
    const result = await services.getAllTaskNames(deduction.groupID, deduction.operationEntityID);
    setTaskCategory(result);
  }

  async function setApplyMethodsData() {
    const result = await services.getApplyMethods();
    setApplyMethods(result);
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, taskTemplateBulkSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
       //groupID: target.value,
       //operationEntityID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      //operationEntityID: target.value,
      //collectionCategoryID: "0",
    });
  }

  function handleChange(e) {
    const target = e.target;

    const value = target.type === "checkbox" ? target.checked : target.value;
    setDeduction({
      ...deduction,
      [e.target.name]: value,
    });
  }

  function SwitchHandleChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    if(value == false){
      setStateData(0)
    }
    setDeduction({
      ...deduction,
      [e.target.name]: value,
    });
  }

  async function handleSave(e) {
     e.preventDefault();
    let TaskSave = {
      groupID: parseInt(deduction.groupID),
      operationEntityID: parseInt(deduction.operationEntityID),
      estateTaskID: parseInt(deduction.estateTaskID),
      sundryTask: parseInt(deduction.sundryTask),
      collectionPointList: selectedOptions,
      taskExpiration: deduction.date,
      numberOfWorkers: parseInt(deduction.numberOfWorkers),
      circulationMonths: parseInt(stateData),
      isActive: deduction.isActive,
      createdBy: parseInt(tokenService.getUserIDFromToken()) 
    }
    const response = await services.SaveTaskTemplateBulk(TaskSave)
    setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    afterSuccessfulyChanged(response.statusCode)
  }

  async function saveData(data) {
    if (!data.isDefaultValueEnabled) {
      data.defaultValue = 0;
    }

    const response = await services.saveData(data);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      setTimeout(() => {
        modalDismissHandler();
        refreshPage();
      }, 1500);
    }
    if (response === "Warning") {
      refreshPage();
    }
  }

  function refreshPage() {
    window.location.reload(false);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function renderDropDown(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }


  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <PageHeader title={pageProperties.title} />
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
                <InputLabel shrink id="groupID">
                  Group *
                </InputLabel>
                <Select
                  fullWidth
                  id="groupID"
                  disabled={
                    isDropdownDisable || !permissionList.isGroupFilterEnabled
                  }
                  name="groupID"
                  value={deduction.groupID}
                  onChange={(e) => handleGroupChange(e.target)}
                >
                  <MenuItem value="0">--Select Group Name--</MenuItem>
                  {renderDropDown(groups)}
                </Select>
                {errors["groupID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>)}
              </div>

              <div className="col-md pb-1">
                <InputLabel shrink id="operationEntityID">
                Operation Entity *
                </InputLabel>
                <Select
                  fullWidth
                  id="operationEntityID"
                  disabled={
                    isDropdownDisable ||
                    !permissionList.isOperationEntityFilterEnabled
                  }
                  name="operationEntityID"
                  value={deduction.operationEntityID}
                  onChange={(e) => handleOperationEntityChange(e.target)}
                >
                  <MenuItem value="0">--Select Operation Entity--</MenuItem>
                  {renderDropDown(estates)}
                </Select>
                {errors["operationEntityID"] && (
                  <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
              </div>
              <div className="col-md pb-1">
                <InputLabel shrink id="estateTaskID">Task Category *</InputLabel>
                <Select
                  fullWidth
                  id="estateTaskID"
                  name="estateTaskID"
                  value={deduction.estateTaskID}
                  onChange={(e) => handleChange(e)}>
                  <MenuItem value="0">--Select Task Category--</MenuItem>
                  {renderDropDown(taskCategory)}
                </Select>
                {errors["taskCategory"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["taskCategory"]}</FormHelperText>)}
              </div>
              <div className="col-md pb-1">
                <InputLabel shrink id="sundryTask">Sundry Task *</InputLabel>
                <Select
                  fullWidth
                  id="sundryTask"
                  name="sundryTask"
                  value={deduction.sundryTask}
                  onChange={(e) => handleChange(e)}>
                  <MenuItem value="0">--Select Sundry Task--</MenuItem>
                  {renderDropDown(labourTask)}
                </Select>
                {errors["sundryTask"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["sundryTask"]}</FormHelperText>)}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
                <MultiSelect
                  items={alldeductionType}
                  getOptionLabel={getOptionLabel}
                  getOptionDisabled={getOptionDisabled}
                  selectedValues={selectedOptions}
                  label="Select Collection Point *"
                  placeholder="Collection Point"
                  selectAllLabel="Select all"
                  onToggleOption={handleToggleOption}
                  onClearOptions={handleClearOptions}
                  onSelectAll={handleSelectAll}
                />
              </div>
              <div className="col-md pb-1">
                <TextField
                  id="date"
                  label="Task Expiration *"
                  name="date"
                  type="date"
                  fullWidth
                  value={deduction.date}
                  onChange={(e) => handleChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {errors["date"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>}
              </div>
              <div className="col-md pb-1">
                <InputLabel shrink id="numberOfWorkers">
                  Number Of Workers
                </InputLabel>
                <TextField
                  fullWidth
                  type="number"
                  name="numberOfWorkers"
                  id="numberOfWorkers"
                  onChange={(e) => handleChange(e)}
                  value={deduction.numberOfWorkers}
                />
                {errors["numberOfWorkers"] && (
                  <FormHelperText
                    id="errbranchCode"
                    className="text text-danger"
                  >
                    {errors["numberOfWorkers"]}
                  </FormHelperText>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <InputLabel shrink id="def">
                    Circulation
                  </InputLabel>
                  <input
                    className="mr-2"
                    id="isCirculation"
                    type="checkbox"
                    switch="none"
                    name="isCirculation"
                    onChange={(e) => SwitchHandleChange(e)}
                    checked={deduction.isCirculation}
                  />
                  <label
                    htmlFor="isCirculation"
                    data-on-label="Yes"
                    data-off-label="No"
                  ></label>
                  {deduction.isCirculation ? (
                    <div className="col-md pb-1">
                      <InputLabel shrink id="def">Months</InputLabel>
                      <ButtonGroup size="small" aria-label="small outlined button group">
                        <Button onClick={handleDecrement}>-</Button>
                        {stateData >= 0 &&<Button>{stateData}</Button>}
                        {stateData >= 0 &&<Button onClick={handleIncrement}>+</Button>}
                      </ButtonGroup>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <InputLabel shrink id="def">
                    Active
                  </InputLabel>
                  <input
                    className="mr-2"
                    id="isActive"
                    type="checkbox"
                    switch="none"
                    name="isActive"
                    onChange={(e) => handleChange(e)}
                    checked={deduction.isActive}
                  />
                  <label
                    htmlFor="isActive"
                    data-on-label="Yes"
                    data-off-label="No"
                  ></label>
                </div>
              </div>
              <div className="card-footer">
                <input
                  onClick={(e) => handleSave(e)}
                  type="button"
                  className="btn btn-primary"
                  value={pageProperties.buttonText}
                />
              </div>
            </form>
          </div>
        </div>
        <MessageModal
          hidden={messageModel.hidden}
          messageType={messageModel.type}
          messageDescription={messageModel.disciption}
          clicked={modalDismissHandler}
        />
      </div>
    </Fragment>
  );
}
